import {noop} from '@github-ui/noop'
import {createContext, type ReactNode, use, useMemo, useState} from 'react'

type FocusTrapManagementContextType = {
  disableFocusTrap: boolean
  setDisableFocusTrap: (disable: boolean) => void
}

const FocusTrapManagementContext = createContext<FocusTrapManagementContextType | null>(null)

type FocusTrapManagementContextProviderType = {
  children: ReactNode
}

export function FocusTrapManagementContextProvider({children}: FocusTrapManagementContextProviderType) {
  const [disableFocusTrap, setDisableFocusTrap] = useState<boolean>(false)

  const contextValue: FocusTrapManagementContextType = useMemo(() => {
    return {
      disableFocusTrap,
      setDisableFocusTrap,
    }
  }, [disableFocusTrap, setDisableFocusTrap])

  return <FocusTrapManagementContext value={contextValue}>{children}</FocusTrapManagementContext>
}

export const useFocusTrapManagementContext = () => {
  const context = use(FocusTrapManagementContext)
  if (!context) {
    return {
      disableFocusTrap: false,
      setDisableFocusTrap: noop,
    }
  }

  return context
}

try{ FocusTrapManagementContext.displayName ||= 'FocusTrapManagementContext' } catch {}
try{ FocusTrapManagementContextProvider.displayName ||= 'FocusTrapManagementContextProvider' } catch {}